import { AutogenModelManifestLookup, AutogenRowManifestLookup } from "./autogen/AutogenModelManifestLookup";

export class ModelManifestLookup extends AutogenModelManifestLookup<RowManifestLookup> {
	constructor() {
		super(RowManifestLookup);
	}
}

export class RowManifestLookup extends AutogenRowManifestLookup {
}